<template>
  <div class="body">
    <div class="form-top">
      <div class="form">
        <form @submit="registration">
          <b-img :src='wifiImage' fluid/>
          <b-form-group :label="$t('Telephone')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <masked-input class="form-control" type="text" :mask="phoneFormat" required v-model="phone"/>
          </b-form-group>
          <b-form-group :label="$t('Tariff')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="options" v-model="reg.tariff_data_id"/>
          </b-form-group>
          <b-button type="submit" variant="success" block>{{ $t('Registration') }}</b-button>
          <b-form-select style="margin-top:10px" v-model="$i18n.locale" :options="local"></b-form-select>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '@/api.js'
import MaskedInput from 'vue-masked-input'
export default {
  components: {
    MaskedInput
  },
  data () {
    return {
      phoneFormat: '1(111)111-11-11',
      phone: '',
      reg: {
        'phone': '',
        'tariff_data_id': 0
      },
      tariffs: [],
      wifiImage: require('@/assets/wifi.png'),
      local: [
        { value: 'en', text: this.$i18n.t('English') },
        { value: 'ru', text: this.$i18n.t('Russian') }
      ]
    }
  },
  methods: {
    registration () {
      this.reg.phone = JSON.parse(JSON.stringify(this.phone))
      axiosInstance.post(this.$store.getters.API_REGISTER_CLIENT, JSON.stringify(this.reg)).then(response => {
        let redirect = response.data.URL
        window.open(redirect, '_blank')
      })
    }
  },
  mounted () {
    axiosInstance.get(this.$store.getters.API_CLIENT_TARIFFS).then(response => {
      this.tariffs = response.data
    })
    axiosInstance.get(this.$store.getters.API_REGISTRY_SETTINGS_PHONE_FORMAT).then(response => {
      this.phoneFormat = response.data.phone_format
    })
  },
  computed: {
    options () {
      let copy = []
      for (let el of this.tariffs) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.cp_utariff_data_id
        newEl.text = el.name
        copy.push(newEl)
      }
      return copy
    }
  },
  watch: {
    options () {
      this.reg.tariff_data_id = this.options[0].value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/captivePortal.vue